import { produce } from 'immer';

import * as Types from './types';
import * as helpers from './helpers';
import { actionTypes } from './constants';
import { SUBSCRIPTIONS_STORE } from '../constants';

export const defaultState: Types.ILiveGamesState = {
    tables: [],
    socket: null,
    isNeedToStart: false,
    isSocketConnected: false,
    isSocketReconnected: false,
    isContextSucceeded: false,
    dynamicImages: {
        timestamp: Date.now(),
        intervalId: null
    }
};

export const reducer = produce((draftState, action: Types.TLiveGamesAction): Types.ILiveGamesState | void => {
    switch (action.type) {
        case actionTypes.LIVE_GAMES_IS_NEED_TO_START_UPDATE: {
            Object.assign(draftState, {
                isNeedToStart: action.payload
            });

            break;
        }

        case actionTypes.LIVE_GAMES_RESET: {
            Object.assign(draftState, {
                tables: [],
                subscriptions: []
            });

            break;
        }

        case actionTypes.LIVE_GAMES_SOCKET_SET: {
            Object.assign(draftState, {
                socket: action.payload
            });

            break;
        }

        case actionTypes.LIVE_GAMES_CONNECTION_STATUS_UPDATE: {
            Object.assign(draftState, {
                isSocketConnected: action.payload
            });

            break;
        }

        case actionTypes.LIVE_GAMES_CONTEXT_STATUS_UPDATE: {
            Object.assign(draftState, {
                isContextSucceeded: action.payload
            });

            break;
        }

        case actionTypes.LIVE_GAMES_RECONNECTION_STATUS_UPDATE: {
            Object.assign(draftState, {
                isSocketReconnected: action.payload
            });

            break;
        }

        case actionTypes.LIVE_GAMES_SUBSCRIPTION_ADD: {
            SUBSCRIPTIONS_STORE.subscriptions.push(action.payload);

            draftState.tables = helpers.mergeTables(draftState.tables, action.payload.tables);

            break;
        }

        case actionTypes.LIVE_GAMES_SUBSCRIPTION_REMOVE: {
            SUBSCRIPTIONS_STORE.subscriptions = SUBSCRIPTIONS_STORE.subscriptions
                .filter((subscription) => !action.payload.includes(subscription.subscriptionId));

            draftState.tables = helpers.syncTablesWithSubscriptions(draftState.tables, SUBSCRIPTIONS_STORE.subscriptions);

            break;
        }

        case actionTypes.LIVE_GAMES_TABLES_ADD: {
            const { tables, subscriptionId } = action.payload;

            draftState.tables = helpers.mergeTables(draftState.tables, tables);

            const activeSubscription = SUBSCRIPTIONS_STORE.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                activeSubscription.tables = activeSubscription.tables.concat(tables);
            }

            break;
        }

        case actionTypes.LIVE_GAMES_TABLES_UPDATE: {
            const { tables, subscriptionId } = action.payload;

            draftState.tables = helpers.updateTables(draftState.tables, tables);

            const activeSubscription = SUBSCRIPTIONS_STORE.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                activeSubscription.tables = helpers.updateTables(activeSubscription.tables, tables);
            }

            break;
        }

        case actionTypes.LIVE_GAMES_TABLES_REMOVE: {
            const { tables, subscriptionId } = action.payload;

            draftState.tables = helpers.removeTables(draftState.tables, tables, SUBSCRIPTIONS_STORE.subscriptions);

            const activeSubscription = SUBSCRIPTIONS_STORE.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                activeSubscription.tables = helpers.removeTables(activeSubscription.tables, tables);
            }

            break;
        }

        case actionTypes.LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE: {
            draftState.dynamicImages.timestamp = action.payload;

            break;
        }

        case actionTypes.LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE: {
            draftState.dynamicImages.intervalId = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
